import {
  Autocomplete,
  Box,
  TextField,
  Typography
} from "@mui/material";
import React from "react";

import { DEFAULT_TIMEZONE, TIMEZONE_OPTIONS } from "../../constants";
import { TimezoneSelectorProps } from "../../types";

const DEFAULT_TIMEZONE_OPTION = TIMEZONE_OPTIONS.find((opt) => opt.value === DEFAULT_TIMEZONE);

export const TimezoneSelector: React.FC<TimezoneSelectorProps> = ({
  value,
  onChange,
  disabled = false
}) => {
  const selectedOption =
    TIMEZONE_OPTIONS.find((opt) => opt.value === value) ?? DEFAULT_TIMEZONE_OPTION;

  return (
    <Autocomplete
      disableClearable
      value={selectedOption}
      onChange={(_event, newValue) => {
        onChange(newValue.value);
      }}
      options={TIMEZONE_OPTIONS}
      groupBy={(option) => option.region}
      getOptionLabel={(option) => `${option.label} (${option.value})`}
      isOptionEqualToValue={(option, val) => option.value === val.value}
      disabled={disabled}
      renderInput={(params) => (
        <TextField {...params} label="Timezone" />
      )}
      renderOption={(props, option) => (
        <Box component="li" {...props} key={option.value}>
          <Box>
            <Typography variant="body2">{option.label}</Typography>
            <Typography variant="caption" color="text.secondary">
              {option.value}
            </Typography>
          </Box>
        </Box>
      )}
    />
  );
};
